var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h2',[_vm._v("Log out of your account")]),_c('b-button',{on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_vm._v(" Log Out ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }